import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { AuthProvider } from "./context/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AuthModal from "./components/AuthModal";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Videos from "./pages/Videos";
import AskRedneck from "./pages/AskRedneck";
import Subscribe from "./pages/Subscribe";
import PaymentSuccess from "./pages/PaymentSuccess";
import OrderHistory from "./pages/OrderHistory";
import About from "./pages/About";
import PennyTest from "./pages/PennyTest";
import Designs from "./pages/Designs";
import DesignDetail from "./pages/DesignDetail";
import Music from "./pages/Music";
import Message from "./pages/Message";
import Downloads from "./pages/Downloads";
import Post from "./pages/Post";
import ThemePlayer from "./components/ThemePlayer";

const PAYPAL_OPTIONS = {
  clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID,
  currency: "USD",
  intent: "capture",
};

function AppShell() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  const openAuth = (mode = "login") => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  return (
    <div className="App min-h-screen flex flex-col bg-[#0A0E0B]">
      <Header onAuthClick={openAuth} />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home onAuthClick={openAuth} />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/designs" element={<Designs />} />
          <Route path="/designs/:name" element={<DesignDetail />} />
          <Route path="/music" element={<Music />} />
          <Route path="/message" element={<Message />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/post" element={<Post />} />
          <Route path="/videos" element={<Videos />} />
          <Route path="/ask" element={<AskRedneck />} />
          <Route path="/subscribe" element={<Subscribe onAuthRequired={() => openAuth("login")} />} />
          <Route path="/orders" element={<OrderHistory />} />
          <Route path="/about" element={<About />} />
          <Route path="/penny-test" element={<PennyTest />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
        </Routes>
      </main>
      <Footer />
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} initialMode={authMode} />
      <ThemePlayer />
      <Toaster theme="dark" position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <PayPalScriptProvider options={PAYPAL_OPTIONS}>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </PayPalScriptProvider>
    </AuthProvider>
  );
}

export default App;
